<template>
  <div
    class="user-profile-sidebar"
    :class="{'show': shallShowActiveChatContactSidebar}"
  >
    <!-- Header -->
    <header
      class="user-profile-header"
    >
      <span class="close-icon">
        <feather-icon
          icon="XIcon"
          @click="$emit('update:shall-show-active-chat-contact-sidebar', false)"
        />
      </span>

      <div class="header-profile-sidebar">
        <div class="avatar box-shadow-1 avatar-xl avatar-border mt-3">
          <b-avatar
            size="130"
            v-if="member.id > 0"
            :src="'//rb.cloudedu.pro/studentPhoto/'+member.uuid+'.jpg'"
          />
          <b-avatar
            v-else
            size="130"
            :src="contact.avatar"
          />
          <!-- <span
            class="avatar-status-xl"
            :class="`avatar-status-${contact.status}`"
          /> -->
        </div>
        
                <b-badge v-if="member.code === ''" variant="light-danger">Non-member</b-badge>
        <router-link
          v-if="member.uuid"
          class="chat-user-name"
          :to="'/apps/student/edit/' + member.uuid + '/'"
        >
          {{ member.zh_name }} {{ member.en_name }}
        </router-link>
        <h4 v-else class="chat-user-name">
          {{ member.zh_name }} {{ member.en_name }}
        </h4>
        <span class="user-post text-capitalize">{{ member.member_code }}</span>
        
      </div>
      <div v-if="member.next_enrollment" class="next-class-info">
        <ul class="list-unstyled">
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-calendar" class="icon-size" />
              <span>{{ member.next_enrollment.class_date ? member.next_enrollment.class_date : null }} {{ member.next_enrollment.time ? member.next_enrollment.time : null }}</span>
            </div>
          </li>
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-pencil" class="icon-size" />
              <span>{{ member.next_enrollment.todo_content ? member.next_enrollment.todo_content : null }}</span>
            </div>
          </li>
          
        </ul>
      </div>
    </header>

    <!-- User Details -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="user-profile-sidebar-area scroll-area"
    >

      <!-- About -->
  
     

      <!-- Personal Info -->
      <div class="personal-info" v-if="member.id > 0">
        <h6 class="section-label mb-1 mt-1">
          Personal Information
        </h6>
        <ul class="list-unstyled">
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-home" class="icon-size" />
              <!-- <span>{{ member.center_name ? member.center_name : null }}</span> -->
              <b-badge variant="light-primary">{{ member.center_name ? member.center_name : null }}</b-badge>
            </div>
          </li>
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-user" class="icon-size" />
              <span>{{ member.zh_name + ' ' + member.en_name ? member.zh_name + ' ' + member.en_name : null }}</span>
            </div>
          </li>
         <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-phone" class="icon-size" />
              <span>{{ member.mobile ? member.mobile : null }}</span>
            </div>
          </li>
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-mercury" class="icon-size" />
              <!-- <span>{{ member.gender ? member.gender : null }}</span> -->
              <b-badge v-if="member.gender === 'M'" variant="primary">Male</b-badge>
              <b-badge v-else-if="member.gender === 'F'" variant="danger">Female</b-badge>
            </div>
          </li>
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-calendar" class="icon-size" />
              <span>{{ member.created_at ? member.created_at : null }}</span>
            </div>
          </li>
          <li class="mb-1">
            <div class="info-inline">
              <font-awesome-icon icon="fa-solid fa-brands fa-app-store-ios" class="icon-size" />
              <span>{{ member.app_last_login_at ? member.app_last_login_at : null }}</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- More Options -->
       <!--
      <div class="more-options">
        <h6 class="section-label mb-1 mt-3">
          Options
        </h6>
        <ul class="list-unstyled">
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="TagIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Add Tag</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="StarIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Important Contact</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="ImageIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Shared Media</span>
          </li>
          <li class="cursor-pointer mb-1">
            <feather-icon
              icon="TrashIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Delete Contact</span>
          </li>
          <li class="cursor-pointer">
            <feather-icon
              icon="SlashIcon"
              size="16"
              class="mr-75"
            />
            <span class="align-middle">Block Contact</span>
          </li>
        </ul>
      </div>
      -->
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BAvatar,BBadge } from 'bootstrap-vue'

export default {
  components: {
    // BSV
    BAvatar,
    BBadge,
    VuePerfectScrollbar,
  },
  props: {
    shallShowActiveChatContactSidebar: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: [String, Number],
      default: '',
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      member: {
        code: '',
        email: '',
        en_name: '',
        zh_name: '',
        id: '',
        mobile: '',
        uuid: '',
      },
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
    }
  },
  watch: {
    shallShowActiveChatContactSidebar(newVal) {
      if (newVal) {
        console.log('member (on open):', this.member)
        this.get_member_data(this.member.uuid)
      }
    },
    customer(newVal) {
      if (newVal === null || newVal === undefined || newVal === '') return
      this.get_member_data_by_mobile(newVal)
    },
    contact: {
      deep: true,
      immediate: true,
      handler(newVal) {
        const uuid = newVal && newVal.member ? newVal.member.uuid : ''
        if (uuid) {
          this.member = {
            ...this.member,
            ...newVal.member,
          }
        }
      },
    },
  },
  methods: {
    resetMember(keepUuid = '') {
      this.member = {
        code: '',
        email: '',
        en_name: '',
        zh_name: '',
        id: '',
        mobile: '',
        uuid: keepUuid || '',
      }
    },
    get_member_data(uuidValue) {
      const uuid = uuidValue !== undefined ? uuidValue : this.member.uuid
      if (!uuid) return

      this.resetMember(uuid)
      this.$http.get(process.env.VUE_APP_API_BASE + `/student/` + uuid + `/`)
        .then(res => {
          const record = res && res.data && (res.data.member || res.data.record || res.data)
          if (record) this.member = { ...this.member, ...record }
          console.log('member (after fetch):', this.member)
        })
    },
    get_member_data_by_mobile(mobile) {
      this.$http.get(process.env.VUE_APP_API_BASE + `/student/whatsapp_search_student/?mobile=` + mobile)
        .then(res => {
          if (res && res.data && res.data.exist === true && res.data.member && res.data.member.uuid) {
            this.get_member_data(res.data.member.uuid)
          }
        })
    }
  },
}
</script>

<style>
.next-class-info {
  background-color: #dcd8b3;
  margin: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
}
.info-inline {
  display: inline-flex;
  align-items: center;
}

.icon-size {
  font-size: 18px;
  margin-right: 0.5rem;
}
</style>
